import standardConsole from './standardConsole';

export { standardConsole };
